<!-- 出货形式 -->
<template>
  <BaseFormItem
    class="units"
    :label="label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in fields.options"
        :key="item.value"
        :label="item.value"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>

    <!-- PCBA下单提示 -->
    <span v-if="isShowTips" slot="other" class="units__tips">
      单片数量较多，建议选择【连片(华秋代拼)】
    </span>
  </BaseFormItem>
</template>

<script>
import { getFPCFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    bcount: {
      type: [Number, String],
      default: ''
    },
    length: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: [String, Number],
      default: ''
    },
    isSmt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFPCFields('units')
    },
    label() {
      return this.isSmt ? '拼板方式' : this.fields.label
    },
    // 是否显示PCBA下单提示
    isShowTips() {
      const { val, isSmt, bcount, length, width } = this
      if (isSmt && bcount && length && width) {
        // PCBA下单 && 单片出货 && 数量 >= 100 && 小边 <= 22.5cm
        return val == 1 && bcount >= 100 && Math.min(length, width) <= 22.5 
      }
      return false
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.units {
  .units__tips {
    font-size: 12px;
    color: $--color-warning;
  }
}
</style>